export function reportFunc() {
	$('#archivesJs').on('click', function () {
		$(this).toggleClass('open').next().slideToggle();
	});
	$('.overseasArchives').on('click', function () {
		$(this).toggleClass('open').next().slideToggle();
	});
}